import React from "react";
import { useNavigate } from "react-router-dom";
import Default from "../Assets/profile.png";
import "../Style/Account.css"
import { useAuth } from "./UserContext.js";

const Account = () => {
  const { currentUser, isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
      console.log("Account Page Current",currentUser)
  const handleEditClick = (field) => {
    navigate("/forgotpassword", { state: { field } });
  };

  return (
    <>
      <h1 className="login-main-h1">My Profile</h1>
      <div className="login-main">
        <div className="userdpdiv">
          <div>
            <img
              src={Default}
              alt="userdp"
            />
            <p>{currentUser?.firstName}</p>
          </div>
        </div>
        <div className="login-main-first">
          <div className="login-main-first-first">
            <label>Name</label>
            <p>{currentUser?.firstName+" "+currentUser?.lastName}</p>
          </div>
          <button
            onClick={() => handleEditClick("name")}
            className="login-main-first-second"
          >
            Edit
          </button>
        </div>
        <div className="login-main-first">
          <div className="login-main-first-first">
            <label>Email</label>
            <p>{currentUser?.email}</p>
          </div>
        </div>
        <div className="login-main-first" style={{ borderBottom: "none" }}>
          <div className="login-main-first-first">
            <label>Password</label>
            <p>********</p>
          </div>
          <button
            onClick={() => {
              navigate("/forgotpassword");
            }}
            className="login-main-first-second"
          >
            Edit
          </button>
        </div>
      </div>
    </>
  );
};

export default Account;